import { render } from "./LandmarksList.vue?vue&type=template&id=9ad3f602&scoped=true"
import script from "./LandmarksList.vue?vue&type=script&lang=js"
export * from "./LandmarksList.vue?vue&type=script&lang=js"

import "./LandmarksList.vue?vue&type=style&index=0&id=9ad3f602&scoped=true&lang=css"

import exportComponent from "/Users/ofmartinez/WebDev/orbeas/Holton-OrbeasRogue-Web-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ad3f602"]])

export default __exports__